import React from 'react';
import styled from 'styled-components';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
  min-height: 300px;
`;

const EmptyStateIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.7;
`;

const EmptyStateTitle = styled.h3`
  font-family: var(--font-serif);
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-gray-600);
  margin-bottom: 0.5rem;
`;

const EmptyStateDescription = styled.p`
  color: var(--color-gray-500);
  margin-bottom: 2rem;
  max-width: 400px;
  line-height: 1.5;
`;

const EmptyStateAction = styled.button`
  background: var(--color-primary);
  color: var(--color-gray-800);
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-lg);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #8BB5E0;
    transform: translateY(-1px);
  }
`;

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = '📭',
  title,
  description,
  action
}) => {
  return (
    <EmptyStateContainer>
      <EmptyStateIcon>{icon}</EmptyStateIcon>
      <EmptyStateTitle>{title}</EmptyStateTitle>
      <EmptyStateDescription>{description}</EmptyStateDescription>
      {action && (
        <EmptyStateAction onClick={action.onClick}>
          {action.label}
        </EmptyStateAction>
      )}
    </EmptyStateContainer>
  );
};

export default EmptyState;